export const message = {
    COMPANY_INFO_UPDATED: "Your company information has been updated",
    PROFILE_UPDATED: "Your profile has been updated",
}